import { useNavigate } from "react-router-dom";
import { Zap, ArrowRight } from "lucide-react";

export default function NextBestAction({ nba }) {
  const navigate = useNavigate();
  return (
    <section className="rounded-2xl bg-[#F5B700]/12 border border-[#F5B700]/30 p-5" data-testid="next-action-card">
      <div className="flex items-center gap-2 text-[#0E395F]">
        <Zap size={16} className="text-[#F5B700]" />
        <span className="text-xs font-black uppercase tracking-widest" data-testid="next-action-title">What's Next?</span>
      </div>
      <p className="text-base font-semibold pv-text-dark mt-2 leading-snug">{nba.insight}</p>
      <button
        data-testid="next-action-cta"
        onClick={() => navigate(nba.cta_link)}
        className="mt-3 inline-flex items-center gap-2 bg-[#0E395F] text-white font-bold rounded-full px-5 py-2.5 text-sm hover:bg-[#164a76] transition-colors"
      >
        {nba.cta_label} <ArrowRight size={16} />
      </button>
    </section>
  );
}
